module.exports = __webpack_public_path__ + "static/edealer-logo-5cade294acf84c695d07a9ef9e8f4c97.png";